require('core-js/fn/array/from');
require('core-js/fn/object/assign');
require('core-js/fn/object/values');
require('core-js/fn/object/keys');
require('core-js/es6/promise');
require('core-js/fn/array/find');
require('core-js/fn/array/includes');
require('core-js/fn/set');
require('core-js/fn/number/is-finite');
